<div class="FormsFinderEnvironment">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly) {
            <div>
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
            </div>
        }
        @else {
            <div>
                <app-pg-form #formComponent [formLayout]="formLayout" [languages]="availableLanguages" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" (valueChange)="onValueChange($event)"></app-pg-form>
            </div>
        }

        <h5 class="my-3 pb-3 border-bottom">{{ 'forms-finder-environment.showcaseContent-title' | locTranslate }}</h5>
        @if (!viewOnly) {
            <div class="row">
                @for (field of showcaseContentFields; track field; let i = $index) {
                    <div  class="col-12 col-sm-6">
                        <app-pg-form-field [fieldData]="field" [(ngModel)]="showcaseContentObject[field.name]" (ngModelChange)="onShowcaseContentValueChange(field.name)"
                        [display]="showcaseContentFieldsDisplay[field.name]"></app-pg-form-field>
                    </div>
                }
            </div>
            <div class="row">
                <div class="col text-end">
                    <button class="btn btn-primary" [disabled]="!canShowcaseContentAdd()" (click)="doShowcaseContentAdd()">{{ 'forms-finder-environment.showcaseContent-add' | locTranslate }}</button>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12 d-flex FormsFinderEnvironment-Showcase py-2">
                @if (showcaseContentList.length == 0) {
                    <div class="FormsFinderEnvironment-Showcase-Empty text-muted">
                        {{ 'forms-finder-environment.showcaseContent-empty' | locTranslate }}
                    </div>
                }
                @for(item of showcaseContentList; track item) {
                    <div>
                        <div class="FormsFinderEnvironment-Showcase-Item rounded bg-light ps-3 me-2 mb-2 d-flex align-items-baseline">
                            <span>{{ item.label }}</span>
                            @if (!viewOnly) {
                                <button type="button" class="btn btn-light text-danger ms-2" (click)="doShowcaseContentRemove(item)"
                                    [attr.aria-label]="'forms-main.a11y.remove-item' | locTranslate">
                                    <i class="fa-regular fa-times" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        
        <h5 class="my-3 pb-3 border-bottom">{{ 'forms-finder-environment.filter-title' | locTranslate }}</h5>
        <div class="row">
            @for (field of filterFields; track field; let i = $index) {
                <div  class="col-12 col-sm-6">
                    @if (!viewOnly) {
                        <app-pg-form-field [languages]="formLanguages" [fieldData]="field" [(ngModel)]="filterObject[field.name]" (ngModelChange)="onFilterValueChange(field.name)"
                        [display]="filterFieldsDisplay[field.name]"></app-pg-form-field>
                    }
                    @if (viewOnly) {
                        <div class="{{ i > 0 ? 'mt-3' : ''}}">
                            <app-pg-detail-field [languages]="formLanguages" [fieldData]="field" [value]="filterObject[field.name]"></app-pg-detail-field>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>